module.exports = __webpack_public_path__ + "static/img/AllInOne5.bc38373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AllInOne5.png
// module id = umlf
// module chunks = 2